import { render } from "./DatabaseMgt.vue?vue&type=template&id=0ed228ea"
import script from "./DatabaseMgt.vue?vue&type=script&lang=js"
export * from "./DatabaseMgt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__